import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isModalOpen: false,
  modalViewName: null,
  modalViewParams: null,
  reload: false,
  info: null
}

const slice = createSlice({
  name: 'accountManagement',
  initialState,
  reducers: {   //Actions
    setCommissionInfo(oldState, action) {
      const info = action.payload;
      oldState.info = info;
    },
    openModal(oldState) {
      oldState.isModalOpen = true;
    },

    closeModal(oldState) {
      oldState.isModalOpen = false;
      oldState.modalViewName = null;
      oldState.modalViewParams = null;
    },

    setModalViewName(oldState, action) {
      oldState.modalViewName = action.payload;
    },

    setModalViewParams(oldState, action) {
      oldState.modalViewParams = action.payload;
    },

    setReload(oldState, action) {
      oldState.reload = action.payload;
    }
  }
});

export const reducer = slice.reducer;

export const setAccountManagement = (info) => (dispatch) => {
  
  dispatch(slice.actions.setAccountManagement(info));
};


export const setModalViewName = (viewName) => (dispatch) => {

  dispatch(slice.actions.setModalViewName(viewName));
};

export const setModalViewParams = (params) => (dispatch) => {

  dispatch(slice.actions.setModalViewParams(params));
}

export const openModal = () => (dispatch) => {

  dispatch(slice.actions.openModal());
};

export const closeModal = () => (dispatch) => {

  dispatch(slice.actions.closeModal());
};

export const setReload = (reload) => (dispatch) => {
  dispatch(slice.actions.setReload(reload))
}


export default slice;
